import { useLayoutEffect } from 'react'

import { EMPTY_LIST } from '../../../constants/common'
import { EmailProfileRaw } from '../EmailProfileRaw'

function EmailProfilePrintLayout({
  messages = EMPTY_LIST,
  requestNumber,
  subject,
}) {
  async function print() {
    await new Promise(requestAnimationFrame)
    await new Promise(requestAnimationFrame)
    window.print()
  }

  useLayoutEffect(() => {
    print()
  }, [])

  return (
    <EmailProfileRaw
      messages={messages}
      requestNumber={requestNumber}
      subject={subject}
    />
  )
}

export default EmailProfilePrintLayout
